import owd from 'owd/owd';

export default class ReCaptcha extends owd.Component {
    init() {
        const sitekey = this.$element.data('sitekey');

        const render = () => {
            if (this.$element.children().length === 0) {
                if (window.grecaptcha && window.grecaptcha.render) {
                    grecaptcha.render(this.$element[0], {
                        sitekey
                    });
                }
            }			
        }

        if (window.grecaptcha && window.grecaptcha.render) {
            render();
        } else {
            this.on('recaptchaready', this.dom.$window, () => {
                render();
            });
        }

        this.on('success error', $('body'), 'form', () => {
            if (window.grecaptcha && window.grecaptcha.reset) {
                grecaptcha.reset();
            }
        });
    }
}

owd.registerComponent('recaptcha', {
    component: ReCaptcha
});